/* const Util = (() => {

    // const settings = {
    //     settingA: true,
    //     settingB: 123,
    //     settingC: "test",
    //     settingD: null
    // };

    // function myPrivateFunction() {

    // }

    // function myOtherPrivateFunction() {

    // }

    return {

        debounce(fn, delay) {
            let id;
            return (...args) => {
                clearTimeout(id);
                id = setTimeout(() => fn.apply(this, args), delay);
            };
        },

        throttle(fn, limit) {
            let lastCall = 0;
            return (...args) => {
                const now = Date.now();
                if (now - lastCall >= limit) {
                    lastCall = now;
                    fn.apply(this, args);
                }
            };
        }
    };
})(); */
